var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShapeHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.2168C0.5 7.53148 1.56674 4.95615 3.46554 3.05734C5.36435 1.15853 7.93968 0.0917969 10.625 0.0917969C13.3103 0.0917969 15.8856 1.15853 17.7845 3.05734C19.6833 4.95615 20.75 7.53148 20.75 10.2168C20.75 12.9021 19.6833 15.4774 17.7845 17.3763C15.8856 19.2751 13.3103 20.3418 10.625 20.3418C7.93968 20.3418 5.36435 19.2751 3.46554 17.3763C1.56674 15.4774 0.5 12.9021 0.5 10.2168H0.5Z",
    fill: "#9945EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3194 8.5293H24.9688C25.1925 8.5293 25.4071 8.61819 25.5654 8.77643C25.7236 8.93466 25.8125 9.14927 25.8125 9.37305V24.5605C25.8125 24.7843 25.7236 24.9989 25.5654 25.1572C25.4071 25.3154 25.1925 25.4043 24.9688 25.4043H9.78125C9.55747 25.4043 9.34286 25.3154 9.18463 25.1572C9.02639 24.9989 8.9375 24.7843 8.9375 24.5605V21.9112C8.36664 21.8291 7.80261 21.705 7.25 21.5399V24.5605C7.25 25.2319 7.51668 25.8757 7.99139 26.3504C8.46609 26.8251 9.10992 27.0918 9.78125 27.0918H24.9688C25.6401 27.0918 26.2839 26.8251 26.7586 26.3504C27.2333 25.8757 27.5 25.2319 27.5 24.5605V9.37305C27.5 8.70172 27.2333 8.05788 26.7586 7.58318C26.2839 7.10848 25.6401 6.8418 24.9688 6.8418H21.9481C22.1118 7.38855 22.235 7.95217 22.3194 8.5293Z",
    fill: "#9945EE",
    stroke: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapeHover);
export default __webpack_public_path__ + "static/media/icon-shape-hover.cbf280f8819ec007d4f61346de3575f1.svg";
export { ForwardRef as ReactComponent };